import {BlockElements} from 'TemplateEditor/Layout/Blocks'
import {Section} from 'TemplateEditor/template'
import {v4 as uuidv4} from 'uuid'

/** Deep-clones a section and assigns new ids for the section and every block (required for drag-and-drop). */
export function cloneSectionWithNewIds(section: Section): Section {
  const cloned = JSON.parse(JSON.stringify(section)) as Section
  cloned.id = uuidv4()
  if (cloned.blocks) {
    for (const key of Object.keys(cloned.blocks)) {
      const pos = Number(key)
      const arr = cloned.blocks[pos]
      if (!Array.isArray(arr)) continue
      cloned.blocks[pos] = arr.map((block: BlockElements) => ({
        ...block,
        id: uuidv4(),
      }))
    }
  }
  return cloned
}

/** Deep-clone a single block with a new id (for duplicate-in-column). */
export function cloneBlockWithNewId(block: BlockElements): BlockElements {
  return {
    ...JSON.parse(JSON.stringify(block)),
    id: uuidv4(),
  } as BlockElements
}
